module.exports = __webpack_public_path__ + "img/about1.6f27a4a7.jpg";